// public/js/ui/breadcrumb.js
// Topbar breadcrumb. Renders a Home icon followed by the current location.
//
// By default the trail is derived from the hash (base page label), so every
// page gets a sensible breadcrumb for free. Detail views can override the trail
// for the current hash via setBreadcrumb([{label, href?}, …]); the override is
// cleared automatically as soon as the hash changes.

const BASE_LABELS = {
  '#map': 'Map',
  '#assets': 'Assets',
  '#alerts': 'Alerts',
  '#devices': 'Devices',
  '#deliveries': 'Deliveries',
  '#distribution': 'Device distribution',
  '#users': 'Users',
  '#tenants': 'Tenants',
  '#feedback': 'Feedback',
  '#settings': 'Settings',
  '#pois': 'POIs',
  '#files': 'Files',
  '#reports': 'Reports',
  '#tracker-config': 'Tracker config',
};

// Sidebar groups (see initNavigation in app.js). A grouped page shows its group
// ahead of it — Home > Operations > Alerts — so the trail matches the sidebar.
// The group is NOT a link: it has no page of its own, and a breadcrumb crumb
// that does nothing when clicked is worse than one that is plainly static.
const GROUP_OF = {
  '#reports': 'Operations',
  '#alerts': 'Operations',
  '#files': 'Operations',
  '#devices': 'Operations',
  '#deliveries': 'Operations',
  '#users': 'Administration',
  '#tenants': 'Administration',
  '#tracker-config': 'Administration',
};

function baseKey(hash) { return (hash || '#map').split('/')[0]; }
function labelFor(hash) {
  const key = baseKey(hash);
  return BASE_LABELS[key] || (key.replace('#', '').replace(/^\w/, c => c.toUpperCase()) || 'Home');
}

let override = null;        // { hash, items }

export function setBreadcrumb(items) {
  override = { hash: baseKey(window.location.hash), items };
  render();
}

function render() {
  const el = document.getElementById('breadcrumb');
  if (!el) return;

  const hash = window.location.hash || '#map';
  let items;
  if (override && override.hash === baseKey(hash)) {
    items = override.items;
  } else {
    override = null;
    items = [{ label: labelFor(hash), href: baseKey(hash) }];
  }

  // Prefix the sidebar group, unless a detail view already built its own trail
  // that starts with it.
  const group = GROUP_OF[baseKey(hash)];
  if (group && items[0]?.label !== group) items = [{ label: group, group: true }, ...items];

  const home = `<a href="#map" class="bc-home" title="Home" aria-label="Home"><i class="fa-solid fa-house"></i></a>`;
  const trail = items.map((it, i) => {
    const last = i === items.length - 1;
    const sep = `<i class="fa-solid fa-chevron-right bc-sep"></i>`;
    const text = it.group
      ? `<span class="bc-group">${it.label}</span>`
      : (it.href && !last
        ? `<a href="${it.href}" class="bc-link">${it.label}</a>`
        : `<span class="bc-current">${it.label}</span>`);
    return `${sep}${text}`;
  }).join('');

  el.innerHTML = home + trail;
}

export function initBreadcrumb() {
  window.addEventListener('hashchange', () => { render(); });
  render();
}

window.setBreadcrumb = setBreadcrumb;
